import React, { useState } from "react";
import { ChevronRight } from "lucide-react";

const SidebarContents = ({ sections }) => {
  const [activeSection, setActiveSection] = useState(
    sections?.[0]?.sectionId
  );

  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleScroll = (sectionId) => {
    const el = document.getElementById(sectionId);
    if (!el) return;

    setActiveSection(sectionId);

    const yOffset = -110;
    const y =
      el.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };


  return (
    <div
        className={`sticky top-16 self-start max-h-[calc(100vh-64px)] overflow-hidden flex-shrink-0 
                    border-r border-gray-200 flex flex-col transition-all duration-300 dark-mode-card
          ${
          isCollapsed ? "w-14" : "w-52"
        }`}
      >
      
      <button
        onClick={() => setIsCollapsed((prev) => !prev)}
        className="flex items-center gap-2 px-3 py-3 text-xs font-semibold text-gray-500 hover:text-emerald-600 border-b border-gray-100 transition-colors"
      >
        <ChevronRight
          className={`w-4 h-4 flex-shrink-0 transition-transform duration-300 ${
            isCollapsed ? "rotate-0" : "rotate-180"
          }`}
        />

        {!isCollapsed && <span>Contents</span>}
      </button>

      <div className="flex-1 overflow-y-auto py-2">
        {sections.map((section, index) => {
          const isActive = activeSection === section.sectionId;

          return (
            <button
              key={section.sectionId}
              onClick={() => handleScroll(section.sectionId)}
              className={`w-full text-left px-3 py-2 text-xs transition-all duration-150 flex items-center gap-2 ${
                isActive
                  ? "text-emerald-700 bg-emerald-50 dark:text-emerald-200 dark:bg-emerald-900 font-semibold border-r-2 border-emerald-500"
                  : "text-gray-600 hover:bg-gray-50 hover:text-gray-900 dark:hover:bg-gray-800 dark:hover:text-gray-50"
              }`}
            >
              <span
                className={`flex-shrink-0 w-4 h-4 rounded-full text-[9px] font-bold flex items-center justify-center`}
              >
                {index + 1}
              </span>

              <span
                className={`leading-tight transition-all duration-200 ${
                  isCollapsed ? "hidden" : "block"
                }`}
              >
                {section.sectionTitle}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SidebarContents;